export default __webpack_public_path__ + "static/media/Chatbotmsg.55fa2d26.png";